import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-20">
      <div className="dw-card rounded-2xl p-8">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#00F0FF]/10"><Mail className="h-6 w-6 text-[#00F0FF]" /></div>
        <h1 className="font-display mt-5 text-2xl font-bold text-white">Reset your password</h1>
        {sent ? (
          <p className="mt-3 text-sm text-slate-300" data-testid="forgot-sent">If that email is registered, a reset link has been sent. Check your inbox.</p>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-4">
            <p className="text-sm text-slate-400">Enter your email and we'll send you a secure reset link.</p>
            <div><Label className="text-slate-300">Email</Label><Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 border-white/10 bg-white/5" data-testid="forgot-email" placeholder="you@example.com" /></div>
            {error && <p className="text-sm text-[#FF2A6D]">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full rounded-xl bg-[#00F0FF] py-6 font-bold text-[#08090E] hover:bg-[#33F3FF]" data-testid="forgot-submit">{loading ? "Sending…" : "Send reset link"}</Button>
          </form>
        )}
        <Link to="/account" className="mt-5 inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-[#00F0FF]" data-testid="forgot-back"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
      </div>
    </div>
  );
}
